import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles'
import { isEmpty, camelCase } from 'lodash'
import './styles.css'
import {
  withStyles,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  CardActions
} from '@material-ui/core'
import SafeLogo from '../../../assets/images/sselogo1(nobackwhite).png'
import Loading from '../../../components/Loading'
import { openSnackBar } from '../../../actions/snack-bar'
import { orgAuth, sendForgotLink } from '../../../actions/authentication'
import update from 'immutability-helper'
import LoadingButton from '../../../components/LoadingButton'
import classNames from 'classnames'
import constant from "../../../config/constant";

const { MESSAGE: { INVALID_EMAIL, SOMETHING_WRONG }, EMAIL_REGEX, ROLE } = constant;

class OrgLogin extends React.Component {
  state = {
    isLoading: false,
    loginEmail: '',
    loginPassword: '',
    forms: {},
    type: 'org',
    formType: 'login',
    forgotEmail: '',
    isMailSending: false
  }

  componentDidMount() {
    // Initial Loading Animation
    let { authenticatedUser } = this.props.authentication
    const { role = '' } = authenticatedUser

    if (!isEmpty(authenticatedUser) && role && role === ROLE.ORGANISATION) {
      this.props.history.push(`/organization/dashboard`)
    } else if (!isEmpty(authenticatedUser)) {
      this.props.dispatch({ type: "LOGOUT" });
      localStorage.clear();
    }

    if (isEmpty(authenticatedUser)) {
      this.setLoading()
    }

    this.setUpForms()
  }

  setLoading = () => {
    this.setState({
      timeout: setTimeout(() => {
        this.setState({
          isLoading: false
        })
        this.setUpForms()
      }, 3800)
    })
  }

  setUpForms = () => {
    const forms = document.querySelectorAll('form')
    forms.forEach(form => {
      const formName = camelCase(form.id)
      const inputs = form.getElementsByTagName('input')
      let newState = update(this.state, {})
      if (!newState.forms[formName]) {
        newState.forms[formName] = {}
      }
      for (let i = 0; i < inputs.length; ++i) {
        newState.forms[formName][inputs[i].name] = {
          validity: inputs[i].validity
        }
      }
      newState.forms[formName].valid = this.formIsValid(
        newState.forms[formName]
      )
      this.setState(newState)
    })
  }

  clearForms = () => {
    this.setState({
      loginEmail: '',
      loginPassword: '',
      forms: {}
    })
  }

  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity
    const formName = camelCase(e.target.form.id)
    let newState = update(this.state, {
      [fieldName]: { $set: value },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: { $set: validity }
          }
        }
      }
    })
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName])
    this.setState(newState)
  }

  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== 'valid') {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  afterLogin = response => {
    const role = response.role;
    if (role === 'admin') this.props.history.push('/admin/manage-organizations')
    else this.props.history.push(`/organization/dashboard`)
  }

  doLogin = e => {
    e.preventDefault()
    let { loginEmail: email, loginPassword: password, type } = this.state
    if (!EMAIL_REGEX.test(email)) {
      this.props.dispatch(
        openSnackBar({
          message: INVALID_EMAIL
        })
      )
      return;
    }
    this.props
      .dispatch(orgAuth({ email, password, type }))
      .then(response => {
        this.afterLogin(response)
      })
      .catch(err => {
        const message = err && err.message || SOMETHING_WRONG;
        this.props.dispatch(
          openSnackBar({
            message
          })
        )
      })
  }

  sendLink = (e) => {
    e.preventDefault();
    const email = this.state.forgotEmail;
    if (!EMAIL_REGEX.test(email)) {
      this.props.dispatch(
        openSnackBar({
          message: INVALID_EMAIL
        })
      )
      return;
    }
    this.setState({ isMailSending: true });
    this.props
      .dispatch(sendForgotLink(email))
      .then(response => {
        this.setState({ isMailSending: false });
        this.props.dispatch(
          openSnackBar({
            message: response.message
          })
        )
      })
      .catch(err => {
        this.setState({ isMailSending: false });
        const message = err && err.message || SOMETHING_WRONG;
        this.props.dispatch(
          openSnackBar({
            message
          })
        )
      })
  }

  forgotPassword = () => {
    this.setState({ formType: 'forgot' });
    setTimeout(() => {
      this.setUpForms()
    }, 100);
  }

  loginOrg = () => {
    this.setState({ formType: 'login' });
    setTimeout(() => {
      this.setUpForms()
    }, 100);
  }

  render() {
    const { classes } = this.props

    const { isLoading, isRegister } = this.state

    return (
      <div className={classes.app}>
        {isLoading ? (
          <Loading />
        ) : (
            <Fragment>
              <span className={classes.header}>
                <img src={SafeLogo} alt="Safe" className={classes.safeLogo} />

              </span>

              <Card
                classes={{
                  root: classNames(classes.cardWrapper, {
                    [classes.isRegister]: isRegister
                  })
                }}
              >
                <div
                  className={classNames(classes.formGroup, {
                    [classes.loginForm]: !isRegister,
                    [classes.registerForm]: isRegister
                  })}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    {this.state.formType === 'login' && <form
                      id="login-form"
                      noValidate
                      autoComplete="off"
                      onSubmit={this.doLogin}
                      className={classes.loginform}
                    >

                      <Typography variant="h6" component="h6" className={classes.loginheading} >
                        LOGIN TO YOUR ACCOUNT
                            </Typography>

                      <CardContent
                        classes={{
                          root: this.props.classes.cardContentRoot
                        }}
                      >
                        <TextField
                          name="loginEmail"
                          id="loginEmail"
                          label="Email Id"
                          type="text"
                          className={classes.textField}
                          margin="normal"
                          value={this.state.loginEmail}
                          onChange={this.handleInputChange}
                        />

                        <TextField
                          id="loginPassword"
                          name="loginPassword"
                          label="Password"
                          className={classes.textField}
                          type="password"
                          autoComplete="nope"
                          margin="normal"
                          value={this.state.loginPassword}
                          onChange={this.handleInputChange}
                        />
                      </CardContent>
                      <CardActions className={classes.wrapper}>
                        <LoadingButton
                          variant="contained"
                          working={this.props.authentication.loggingIn}
                          disabled={!this.state.loginEmail || !this.state.loginPassword}
                          className={classes.largeButton}
                          type="submit"
                        >  LOGIN
                              </LoadingButton>
                        <div className={classes.button}>

                          {/* Forgot Login */}

                          <Button
                            style={{ color: '#999' }}
                            onClick={this.forgotPassword}
                          >
                            Forgot Password?
                                </Button>
                        </div>
                      </CardActions>
                    </form>}
                    {this.state.formType === 'forgot' && <form
                      id="forgot-form"
                      noValidate
                      autoComplete="off"
                      onSubmit={this.sendLink}
                      className={classes.loginform}
                    >

                      <Typography variant="h6" component="h6" className={classes.loginheading} >
                        Forgot password?
                          </Typography>

                      <CardContent
                        classes={{
                          root: this.props.classes.cardContentRoot
                        }}
                      >
                        <TextField
                          name="forgotEmail"
                          id="forgotEmail"
                          label="Email Id"
                          type="text"
                          className={classes.textField}
                          margin="normal"
                          value={this.state.forgotEmail}
                          onChange={this.handleInputChange}
                        />
                      </CardContent>

                      <CardActions className={classes.wrapper}>
                        <LoadingButton
                          variant="contained"
                          className={classes.largeButton}
                          working={this.state.isMailSending}
                          disabled={!this.state.forgotEmail}
                          type="submit"
                        >
                          Submit
                            </LoadingButton>

                        <LoadingButton
                          variant="contained"
                          onClick={this.loginOrg}
                          className={classes.largeCustomButton}
                        >
                          Back To login
                            </LoadingButton>
                      </CardActions>
                    </form>}
                  </div>
                </div>
              </Card>
            </Fragment>
          )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(OrgLogin)
